import React, { FC, useState } from 'react';
import styles from './InfoComponent.module.css';
import infobutton from '../../../icons/austria/Information_Midnight_32px.svg';
// import dropdown from '../../../icons/austria/Arrow_Down_Midnight_16px.svg';
import { Icon } from '@plone/volto/components';
// /home/dweisgram/Downloads/
interface InfoComponentProps {
  informationLink: string;
  language: string;
}

const InfoComponent: FC<InfoComponentProps> = React.memo(
  ({ informationLink, informationText, language }) => {
    const [isButtonVisible, setIsButtonVisible] = useState(true);

    const handleButtonClick = () => {
      setIsButtonVisible(!isButtonVisible);
      //   onInfoClick(); // could be added later
    };
    const isMobile = window.innerWidth <= 650;
    const createLinkText = (href: string, language: string): JSX.Element => {
      return (
        <>
          {' '}
          <a
            tabIndex={0}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={'Link zu Informationsseite:' + href}
          >
            {language === 'de' ? 'hier' : 'here'}
          </a>
        </>
      );
    };
    // const last_char = informationText?.slice(-1) == '.' ? ' ' : '. ';
    return (
      <div className={styles.infoContainer}>
        <button
          // onClick={handleButtonClick}
          aria-label="Öffnet eine kurze Beschreibung und zeigt dann den passenden Link zu mehr Informationen an"
        >
          {' '}
          <Icon
            className={styles.infoButton}
            // onClick={handleButtonClick}
            name={infobutton}
            size={isMobile ? '24px' : '32px'}
            title={informationText}
          />{' '}
        </button>

        {isButtonVisible && (
          <span className={styles.infoText}>
            {informationText}
            {createLinkText(informationLink, language)}
          </span>
        )}
      </div>
    );
  },
);

export default InfoComponent;
